import { RouterProvider } from "react-router-dom"
import { QueryProvider } from "@/app/providers/QueryProvider"
import { AuthProvider } from "@/app/providers/AuthProvider"
import { router } from "@/app/router"
import { ErrorToastContainer } from "@/shared/components/ui/ErrorToastContainer"

function App() {
  return (
    <QueryProvider>
      <AuthProvider>
        <RouterProvider router={router} />
        <ErrorToastContainer />
      </AuthProvider>
    </QueryProvider>
  )
}

export default App
